import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { currentUserRole } from 'utils/currentUser';

export const shouldComponentRender = (config) => {
  const userRole = currentUserRole();
  const hiddenTo = get(config, 'hiddenTo', []);
  const visibleTo = get(config, 'visibleTo', []);

  if (hiddenTo.includes(userRole)) {
    return false;
  }
  if (visibleTo.includes(userRole)) {
    return true;
  }
  if (!isEmpty(hiddenTo)) {
    return true;
  }
  return false;
};

const ACL = ({ visibleTo, hiddenTo, children }) => (
  shouldComponentRender({ visibleTo, hiddenTo }) ? children : null
);

ACL.defaultProps = {
  visibleTo: [],
  hiddenTo: [],
};

ACL.propTypes = {
  visibleTo: PropTypes.array, // eslint-disable-line
  hiddenTo: PropTypes.array, // eslint-disable-line
};

export default ACL;
